export default __webpack_public_path__ + "static/media/LAS1000.34I-43772_-26131_0.044c1364.jpg";